import { render, staticRenderFns } from "./Compare.svg.vue?vue&type=template&id=d7bfee7e"
import script from "./Compare.svg.vue?vue&type=script&lang=ts"
export * from "./Compare.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7bfee7e')) {
      api.createRecord('d7bfee7e', component.options)
    } else {
      api.reload('d7bfee7e', component.options)
    }
    module.hot.accept("./Compare.svg.vue?vue&type=template&id=d7bfee7e", function () {
      api.rerender('d7bfee7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Compare.svg.vue"
export default component.exports